var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaxBonusAmountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10a6 6 0 11-12 0 6 6 0 0112 0zm2 0a8 8 0 11-16 0 8 8 0 0116 0zm-6.073 3.087c.382-.386.573-.896.573-1.53 0-.35-.065-.657-.194-.92a2.09 2.09 0 00-.603-.724c-.272-.219-.732-.478-1.38-.777V7.373a4.661 4.661 0 011.594.466l.469-1.398a4.877 4.877 0 00-2.062-.55V5H9.64v.915c-.674.08-1.2.306-1.578.68-.375.372-.563.846-.563 1.424 0 .537.136.99.408 1.356.276.363.742.7 1.4 1.01l.333.156v1.853a4.784 4.784 0 01-1.09-.233 5.173 5.173 0 01-1.041-.454v1.577c.61.323 1.321.495 2.131.515V15h.683v-1.225c.687-.076 1.222-.305 1.603-.688zm-1.095-1.865c.113.116.169.257.169.425 0 .378-.226.613-.677.705v-1.488c.226.123.395.243.508.358zM9.148 8.455A.645.645 0 019 8.019c0-.34.214-.546.642-.622v1.405a1.868 1.868 0 01-.493-.347z",
    fill: "#9A9CAC"
  })));
}

export default SvgMaxBonusAmountIcon;